
    import * as React from 'react';

    const ArrowAngleUp20 = ({ color = 'currentcolor', height = '20px', width = '20px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 20 20" fill="none" style={svgStyle}><path fillRule="evenodd" clipRule="evenodd" d="M15.094 6.22694L14.4905 14.0717L15.4876 14.1484L16.2394 4.37437L6.46543 5.12622L6.54212 6.12327L14.3869 5.51983L3.67535 16.2313L4.38245 16.9385L15.094 6.22694Z" /></svg>
        </div>
      );
    };

    ArrowAngleUp20.displayName = 'ArrowAngleUp20';

    export default ArrowAngleUp20;
  